const hydrate = () => {
  const headings = document.querySelectorAll(
    `[data-scalar-type="heading"]`
  );
  headings.forEach((heading) => {
    const button = heading.querySelector(".notify-container");
    if (button && !button.hasAttribute("hydrated")) {
      button.addEventListener("click", () => handleHeaderLink(heading));
      button.setAttribute("hydrated", "true");
    }
  });
  return true;
};
function handleHeaderLink(element) {
  window.location.hash = `#${element.id}`;
  navigator.clipboard.writeText(`${window.location.href}`);
  element.classList.add("show-copied");
  setTimeout(() => element?.classList.remove("show-copied"), 1200);
}
export {
  hydrate
};
//# sourceMappingURL=hydration.js.map
